import * as actionTypes from '../constants/StoreConstants';

const initialState = {
  eventByIdData: {},
  colorData: {},
};

const EventReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.storeConstants.GET_EVENT:
      return {
        ...state,
        eventByIdData: action.payload,
      };
    case actionTypes.storeConstants.CLEAR_EVENT:
      return {
        ...state,
        eventByIdData: {},
      };
    case actionTypes.storeConstants.SET_PREVIEWCOLOR:
      return {
        ...state,
        colorData: action.payload,
      };
    default:
      return state;
  }
};

export default EventReducer;
